<template>
    <div class="content">
        <div class="loading hvc">
            <h3>正在载入...</h3>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    import axios from '@/libs/api.request'
    export default {
        name: 'MiddlePage',
        data: () => {
            return {}
        },
        mounted () {
            this.createToken()
                .then(res => {
                    this.setToken(res)
                    this.$router.push('/member/index')
                })
                .catch(err => {
                    window.console.log(err)
                })
        },
        methods: {
            ...mapMutations([ 'setToken']),
            createToken () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/ApiTokenAuth/Authenticate',
                        method: 'post',
                        data: {
                            cmsId: this.$store.state.user.cmsId
                        }
                    })
                        .then(res => {
                            window.console.log(res)
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loading{
    height: 100vh;
}
</style>
